import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

/**
 * Provide any value that can be converted to date with moment
 */
@Pipe({ name: 'utcOffsetConversion' })
export class UtcOffsetConversion implements PipeTransform {
  transform(time: any, offset: number): Date {
    const newStr = moment(time).add(offset, 'minute');;
    return newStr.toDate();
  }
}